module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/step1-3-875c08263410a051ed4167c2652cc38a.gif";